/**
 * Updates the recently viewed products in localStorage.
 * Restricts stored products strictly to the active Winter and Pants catalog.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in local storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  static #VALID_CATALOG = [
    'priama', 'macha', 'chrysipa', 'polyda', 'tullia',
    'alexora', 'vanora', 'dosona', 'demora', 'agesta',
    'malabara', 'helena', 'sylvestra',
    'white-pants', 'beige-pants', 'light-denim', 'dark-denim',
    'baby-blue-pants', 'mint-green', 'navy-blue', 'pink',
    '10579086311743', '10579092406591', '10579089719615', '10579089359167',
    '10579088671039', '10579088310591', '10579087917375', '10579085558079'
  ];

  static #normalize(id) {
    if (!id) return '';
    return String(id).toLowerCase().trim().replace(/^winter-|^pants-/, '');
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID or handle of the product to add.
   */
  static addProduct(productId) {
    const norm = this.#normalize(productId);
    if (!this.#VALID_CATALOG.includes(norm)) {
      return; // Do not record old summer / archived products
    }

    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter((id) => this.#normalize(id) !== norm);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (e) {}
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch (e) {}
  }

  /**
   * Retrieves the list of recently viewed products from local storage.
   * Cleans any legacy/unapproved items automatically.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const raw = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      const clean = raw.filter((id) => this.#VALID_CATALOG.includes(this.#normalize(id)));
      if (clean.length !== raw.length) {
        localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(clean));
      }
      return clean;
    } catch (e) {
      return [];
    }
  }
}
